import { Box, Paper, Typography, useTheme } from '@mui/material';
import NoTaskOpenIcon from '../../icons/NoTaskOpenIcon';

/**
 * NoDataPresentUI
 *
 * A reusable UI component that displays a message when no data or tasks are available.
 * This component includes an icon, a heading, and customizable styles, making it suitable for
 * displaying a friendly "no data" message in various sections of an app.
 *
 * @param {string} heading - Text to display as the main message. Defaults to 'Hey! No task has open yet!'.
 * @param {JSX.Element} icon - An icon component to display above the heading. Defaults to `NoTaskOpenIcon`.
 * @param {object} containerSx - Custom styles for the container box, allowing for style overrides.
 * @param {...object} props - Any additional props to pass to the container box.
 *
 * @returns {JSX.Element} - A centered message box with an icon and heading, indicating no data presence.
 */
const NoDataPresentUI = ({ heading = 'Open a task to view more details here!', icon = <NoTaskOpenIcon />, containerSx = {}, footerButton, ...props }) => {
    const theme = useTheme();
    return (
        <Box
            component={Paper}
            width={'40%'}
            height={'100%'}
            // bgcolor={theme.palette.background.paper}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            flexDirection={'column'}
            gap={'1.5rem'}
            padding={'1rem'}
            backgroundColor={'transparent'}
            sx={{
                ...containerSx,
            }}
            {...props}
        >
            <Box className="icon">{icon}</Box>
            <Typography component={'p'} color={'grey.100'} textAlign={'center'} fontSize={'customFontSize.large'} fontWeight={'fontWeightSemiBold'} lineHeight={'normal'}>
                {heading}
            </Typography>

            {footerButton && <>{footerButton}</>}
        </Box>
    );
};

export default NoDataPresentUI;
